export default "__VITE_ASSET__BOdVy3ox__"